const dateTimeFormats = {
    'en': {
        short: {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        },
        long: { 
          year: 'numeric', 
          month: 'short',
          day: 'numeric',
          weekday: 'short',
          hour: 'numeric',
          minute: 'numeric',
          hour12: true
        }
      },
    'fr': {
       short: {
         year: 'numeric',
         month: 'short',
         day: 'numeric'
       },
       long: {
         year: 'numeric',
         month: 'long',
         day: 'numeric',
         weekday: 'short',
         hour: 'numeric',
         minute: 'numeric'
       }
     }
  }
  export default dateTimeFormats
